module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"NewsletterForm":{"button":"Přihlásit","email":"E-mail","label":"Přihlásit se k odběru newsletteru","newsletterCompliance":{"text":"Odesláním souhlasíte se","linkText":"zpracováním osobních údajů"},"placeholder":"Váš e-mail","notifications":{"empty":"Pokud chcete dostávat novinky, musíte vyplnit e-mail.","success":"Přihlášení bylo úspěšné"}}}}')
  delete Component.options._Ctor
}
